import { createSlice } from "@reduxjs/toolkit";

interface IPreferencesState {
  isLoading: boolean;
  isLeftNavExpanded: boolean;
  isConsentProvided: boolean;
  isConsentFormOpen: boolean;
  caseDetailCurrentNavIndex: Number;
}

export const currentPrefsInitialState: IPreferencesState = {
  isLoading: false,
  isLeftNavExpanded: localStorage.getItem("toggleMenu") === "true",
  isConsentProvided: false,
  isConsentFormOpen: false,
  caseDetailCurrentNavIndex: 0,
};

const currentPreferencesSlice = createSlice({
  name: "currentPreferences",
  initialState: currentPrefsInitialState,
  reducers: {
    showLoader: (state) => {
      state.isLoading = true;
    },
    hideLoader: (state) => {
      state.isLoading = false;
    },
    setLeftNavExpand: (state, action) => {
      state.isLeftNavExpanded = action.payload;
      localStorage.setItem("toggleMenu", action.payload.toString());
    },
    setConsentProvided: (state, action) => {
      state.isConsentProvided = action.payload;
      localStorage.setItem("isConsentProvided", String(action.payload));
    },
    setConsentFormOpen: (state, action) => {
      state.isConsentFormOpen = action.payload;
    },
    setCaseDetailCurrentNavIndex: (state, action) => {
      state.caseDetailCurrentNavIndex = action.payload;
    },
  },
});

export const {
  showLoader,
  hideLoader,
  setLeftNavExpand,
  setConsentProvided,
  setConsentFormOpen,
  setCaseDetailCurrentNavIndex,
} = currentPreferencesSlice.actions;
export default currentPreferencesSlice;

export const setLoading = (isLoading: boolean) => {
  //const dispatch = useDispatch();
  isLoading ? showLoader() : hideLoader();
};
